"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ganttlab_entities_1 = require("ganttlab-entities");
var ViewProjectGitLabStrategy_1 = require("./strategies/ViewProjectGitLabStrategy");
var ViewProject = /** @class */ (function (_super) {
    __extends(ViewProject, _super);
    function ViewProject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slug = 'project';
        _this.name = 'By project';
        _this.shortDescription = 'Issues within a project';
        _this.slugStrategies = {
            gitlab: new ViewProjectGitLabStrategy_1.ViewProjectGitLabStrategy(),
        };
        _this.configuration = {
            project: null,
            tasks: {
                page: 1,
                pageSize: 50,
            },
        };
        return _this;
    }
    ViewProject.prototype.setSort = function (sort) {
        throw new Error('Method not implemented.');
    };
    ViewProject.prototype.reverseSort = function () {
        throw new Error('Method not implemented.');
    };
    ViewProject.prototype.setFilter = function (filter) {
        throw new Error('Method not implemented.');
    };
    return ViewProject;
}(ganttlab_entities_1.SourceVisitor));
exports.ViewProject = ViewProject;
//# sourceMappingURL=ViewProject.js.map